/**
 * DEV-1801. Отказ справочника в форме клиента: подпись под полем.
 *
 * Отдельным модулем, как propertyShowcase/showcaseGallery: правки клиентских форм не конфликтуют
 * с общим ru.ts.
 */

const ruForm = {
  leadSourceLoadError: 'Не удалось загрузить источники лида',
}

const enForm = {
  leadSourceLoadError: 'Failed to load lead sources',
}

const vnForm = {
  leadSourceLoadError: 'Không tải được nguồn khách hàng',
}

// Своя строка, а не common.actions.retry: на той же форме соседний селект пишет
// «Повторить» строкой дизайн-системы, и два слова для одного действия путают.
const ruReferences = { loadError: { retry: 'Повторить' } }
const enReferences = { loadError: { retry: 'Retry' } }
const vnReferences = { loadError: { retry: 'Thử lại' } }

export const clientLeadSourceMessages = {
  ru: { clients: { form: ruForm }, references: ruReferences },
  en: { clients: { form: enForm }, references: enReferences },
  vn: { clients: { form: vnForm }, references: vnReferences },
}
